var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"imageExt":"svg","imageName":"freeway","welcomeGroup":"Freeway Customers","routePath":"freeway"}})
}
var staticRenderFns = []

export { render, staticRenderFns }